var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDogeBoxDeskBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 539,
    height: 129,
    viewBox: "0 0 539 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1001 15.73L22.1001 45.98V108.48L52.1001 78.23V15.73Z",
    fill: "#F9F0DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3381 15.1521C52.5723 15.2485 52.7251 15.4767 52.7251 15.73V78.23C52.7251 78.3949 52.66 78.5531 52.5439 78.6701L22.5439 108.92C22.3655 109.1 22.0963 109.154 21.8621 109.058C21.6279 108.961 21.4751 108.733 21.4751 108.48V45.98C21.4751 45.8151 21.5402 45.657 21.6563 45.5399L51.6563 15.2899C51.8347 15.1101 52.1039 15.0556 52.3381 15.1521ZM22.7251 46.2374V106.962L51.4751 77.9726V17.2478L22.7251 46.2374Z",
    fill: "#020202"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M521.11 15.73H52.1001V78.23H521.11V15.73Z",
    fill: "#F9F0DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4751 15.73C51.4751 15.3848 51.7549 15.105 52.1001 15.105H521.11C521.455 15.105 521.735 15.3848 521.735 15.73V78.23C521.735 78.5752 521.455 78.855 521.11 78.855H52.1001C51.7549 78.855 51.4751 78.5752 51.4751 78.23V15.73ZM52.7251 16.355V77.605H520.485V16.355H52.7251Z",
    fill: "#020202"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M51.3201 15.73L21.3201 45.98V108.48L51.3201 78.23H520.34V15.73H51.3201Z",
    fill: "#020202"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5403 24.3163C52.7853 24.5594 52.7869 24.9551 52.5438 25.2002L22.5438 55.4402C22.3007 55.6852 21.905 55.6868 21.6599 55.4437C21.4149 55.2006 21.4133 54.8049 21.6564 54.5598L51.6564 24.3198C51.8995 24.0748 52.2952 24.0732 52.5403 24.3163Z",
    fill: "#020202"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5402 33.5162C52.7853 33.7593 52.7869 34.155 52.5439 34.4001L22.5439 64.6501C22.3008 64.8952 21.9051 64.8968 21.66 64.6537C21.4149 64.4107 21.4133 64.0149 21.6563 63.7699L51.6563 33.5199C51.8994 33.2748 52.2951 33.2731 52.5402 33.5162Z",
    fill: "#020202"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5402 44.0362C52.7853 44.2793 52.7869 44.675 52.5439 44.9201L22.5439 75.1701C22.3008 75.4152 21.9051 75.4168 21.66 75.1738C21.4149 74.9307 21.4133 74.535 21.6563 74.2899L51.6563 44.0399C51.8994 43.7948 52.2951 43.7931 52.5402 44.0362Z",
    fill: "#020202"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5402 53.2462C52.7853 53.4892 52.7869 53.885 52.5439 54.13L22.5439 84.38C22.3008 84.6251 21.9051 84.6268 21.66 84.3837C21.4149 84.1407 21.4133 83.7449 21.6563 83.4998L51.6563 53.2498C51.8994 53.0047 52.2951 53.0031 52.5402 53.2462Z",
    fill: "#020202"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5402 62.9561C52.7853 63.1992 52.7869 63.5949 52.5439 63.84L22.5439 94.09C22.3008 94.3351 21.9051 94.3367 21.66 94.0937C21.4149 93.8506 21.4133 93.4549 21.6563 93.2098L51.6563 62.9598C51.8994 62.7147 52.2951 62.7131 52.5402 62.9561Z",
    fill: "#020202"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogeBoxDeskBack);
export default __webpack_public_path__ + "static/media/doge-box-desk-back.1d13afa9d8248e4f1e1d5a300abe2cef.svg";
export { ForwardRef as ReactComponent };